import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUIRichTextRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/RichText/SDUIRichTextRenderer";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import React from "react";
export var SDUISiteBannerRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData;
    var _siteBannerComponent_style, _siteBannerComponent_style1;
    var siteBannerComponent = component.site_banner_component;
    if (!siteBannerComponent) {
        return null;
    }
    var description = siteBannerComponent.description;
    var mobileValue = description === null || description === void 0 ? void 0 : description.mobile_and_above;
    var _description_tablet_and_above;
    var tabletValue = (_description_tablet_and_above = description === null || description === void 0 ? void 0 : description.tablet_and_above) !== null && _description_tablet_and_above !== void 0 ? _description_tablet_and_above : mobileValue;
    var _description_desktop_and_above;
    var desktopAndAboveValue = (_description_desktop_and_above = description === null || description === void 0 ? void 0 : description.desktop_and_above) !== null && _description_desktop_and_above !== void 0 ? _description_desktop_and_above : tabletValue;
    var backgroundColor = ((_siteBannerComponent_style = siteBannerComponent.style) === null || _siteBannerComponent_style === void 0 ? void 0 : _siteBannerComponent_style.background_color) ? getSlateColorToken((_siteBannerComponent_style1 = siteBannerComponent.style) === null || _siteBannerComponent_style1 === void 0 ? void 0 : _siteBannerComponent_style1.background_color) : Decorative.tint.neutral;
    var _siteBannerComponent_button_variant;
    return /*#__PURE__*/ _jsx("div", {
        className: "relative ml-[calc(-50vw+50%)] flex w-screen items-center justify-center px-6 py-2",
        style: {
            backgroundColor: backgroundColor
        },
        "data-test-id": "site-banner-renderer",
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                    noJS: true,
                    mobile: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: mobileValue
                    }),
                    tablet: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: tabletValue
                    }),
                    desktopAndAbove: /*#__PURE__*/ _jsx(SDUIRichTextRenderer, {
                        richTextElement: desktopAndAboveValue
                    })
                }),
                " ",
                siteBannerComponent.button ? /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                    buttonElement: _object_spread_props(_object_spread({}, siteBannerComponent.button), {
                        variant: (_siteBannerComponent_button_variant = siteBannerComponent.button.variant) !== null && _siteBannerComponent_button_variant !== void 0 ? _siteBannerComponent_button_variant : IButtonElement.ButtonVariant.TERTIARY
                    }),
                    loggingData: loggingData
                }) : null
            ]
        })
    });
};
